<div class="u-wrapper">
	<div class="c-card u-osb-md o-grid__cell--center-h">
		<div class="c-content c-content--lg">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell">
					<div>
						<img id="benuLogo1" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 45%" class="u-hidden@md-and-up">
						<img id="benuLogo2" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 10%" class="u-hidden@up-to-md">
					</div>
					<br/>
					<h1 id="benuThankYouHeaderLabel" class="c-text c-text--heading c-text--s6 c-text--lg">
						{{'Benu.Thank_You_Page.Header' | translate}}
					</h1>
					<br/>
					<p>{{'Benu.Thank_You_Page.Text_Row_1' | translate}}</p>
					<br/>
					<p>{{'Benu.Thank_You_Page.Text_Row_2' | translate}}</p>
					<br/>
					<p>{{'Benu.Thank_You_Page.Text_Row_3' | translate}}</p>
					<br/>
				</div>
			</div>
		</div>
	</div>
</div>
